// extracted by mini-css-extract-plugin
export default {"ScreenKeyboard":"ScreenKeyboard_ScreenKeyboard__-WYO0","Small":"ScreenKeyboard_Small__JA8D7"};